<mat-toolbar color="accent" class="min-h-[50px]">
  {{ isEdit ? 'Edit' : 'Add' }} Automated Notification
</mat-toolbar>

<div class="flex flex-col overflow-scroll bg-slate-100">
  <pr-automated-notification-edit
    #form="prAutomatedNotificationEdit"
    class="p-4"
    context="data.context"
    [notification]="data.notification"
    [scope]="data.scope"
    [scopeData]="data.scopeData"
    [useRelativeTime]="data.useRelativeTime"
    [triggerDate]="data.triggerDate"
    [configRef]="data.configRef"
  />
</div>

<pt-page-footer>
  <pt-buttons-container padding="none">
    <button type="button" mat-stroked-button mat-dialog-close>Cancel</button>
    <button
      type="submit"
      mat-flat-button
      color="primary"
      [disabled]="form.form.invalid"
      (click)="submit(form)"
    >
      Submit
    </button>
  </pt-buttons-container>
</pt-page-footer>
